module.exports = __webpack_public_path__ + "static/media/hero__tournaments.c1df49c7.jpg";